import { useState } from "react";
import {
    buildRejectedAppsXlsxAndDownload,
    fetchAllRejectedApplicationPages,
    REJECTED_APPS_EXPORT_PAGE_SIZE,
} from "../utils/rejectedApplications";

export const useRejectedApplicationsExport = () => {
    const [isExporting, setIsExporting] = useState(false);
    const [progressPercent, setProgressPercent] = useState(0);
    const [exportError, setExportError] = useState(null);
    const [exportSuccess, setExportSuccess] = useState(false);

    const startExport = async (scope, currentPageRows, queryFilters) => {
        setIsExporting(true);
        setExportError(null);
        setProgressPercent(0);
        setExportSuccess(false);

        try {
            let rowsToExport;

            if (scope === "current") {
                rowsToExport = currentPageRows;
            } else {
                rowsToExport = await fetchAllRejectedApplicationPages(
                    queryFilters,
                    REJECTED_APPS_EXPORT_PAGE_SIZE,
                    (current, total) => {
                        setProgressPercent(total > 0 ? Math.round((current / total) * 100) : 100);
                    }
                );
            }

            const formattedDate = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
            const filename = `Rejected_Applications_${formattedDate}.xlsx`;

            await buildRejectedAppsXlsxAndDownload(rowsToExport, filename);
            setExportSuccess(true);
        } catch (error) {
            console.error("Rejected Applications export failed:", error);
            setExportError("Export failed. Please try again.");
        } finally {
            setIsExporting(false);
        }
    };

    return { isExporting, progressPercent, exportError, exportSuccess, startExport };
};